
// @ngInject
function scorecardReportState($stateProvider, TagUrl) {

    var url = new TagUrl()
        .addTagTypes(['program', 'location'])
        .setTagDefault('scorecard', 'yes');


    $stateProvider.state('reports.scorecard', {
        url: url.buildUrl('/scorecard'),
        params: url.params,
        templateUrl: 'reports/scorecard',
        data: {tagUrl: url},
        controller: 'ScorecardReportController',
        controllerAs: '$ctrl',
        reloadOnSearch: false,
    });
}

function ScorecardReportController(ScorecardService) {

    var vm = this;

    vm.tags = null;
    vm.page = 1
    vm.size = 10
    vm.sort = "name"

    vm.columns = [
        {name: 'practices', label: 'Site Score'},
        {name: 'scorecard', label: 'Internal Score'},
        {name: 'overall', label: 'Total Score'},
    ]

    this.tagChange = tagChange;
    this.refresh = refresh;

    function tagChange(params) {
        vm.tags = params;
        vm.refresh();
    }

    function refresh() {
        var params = angular.copy(vm.tags);
        params.sort = vm.sort;
        vm.loading = true;
        ScorecardService.report(params).then(function(response) {
            vm.data = response.data;
            vm.meta = response.meta;
            vm.page = 1;
            vm.pages = Math.ceil(vm.meta.programs / vm.size);
            vm.loading = false;
        });
    }
}

module
    .controller('ScorecardReportController', ScorecardReportController)
    .config(scorecardReportState)
